/** Access permissions for a NEW line, not the protocol used by the web player. */
export const DEFAULT_ACCESS_OUTPUT = 'ambos';
export const ACCESS_OUTPUT_OPTION_IDS = ['ambos', 'mpegts', 'hls'];

export function accessOutputToAllowedIds(value = DEFAULT_ACCESS_OUTPUT) {
  const output = String(value || DEFAULT_ACCESS_OUTPUT).trim().toLowerCase();
  if (output === 'hls') return [1];
  if (output === 'mpegts') return [2];
  return [1, 2];
}
